import { Page } from '@/core/architecture'

import { NftItemsTemplate } from './template'
import { useViewModel } from './viewModel'

export const NftItems: Page = () => {
  const { state, actions } = useViewModel()

  return <NftItemsTemplate state={state} />
}
